import api from "@/api/v1-jwt/config/api";
import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import {
  CreateRecurringInvoicePayload,
  RecurringInvoiceSchedule,
  RecurringInvoiceScheduleSchema,
} from "../types";
import { createErrorHandler } from "@/utils/errorHandler";

type CreateRecurringInvoiceParams = {
  userId: string;
  payload: CreateRecurringInvoicePayload;
};

const createRecurringInvoice = async ({
  userId,
  payload,
}: CreateRecurringInvoiceParams): Promise<RecurringInvoiceSchedule> => {
  const url = `/platform/invoices/${userId}/recurring`;
  const response = await api.post(url, payload);
  return RecurringInvoiceScheduleSchema.parse(response.data.data);
};

export const recurringInvoiceCreate = {
  createOptions: (
    options?: UseMutationOptions<
      RecurringInvoiceSchedule,
      Error,
      CreateRecurringInvoiceParams
    >
  ) => {
    const defaultOptions: UseMutationOptions<
      RecurringInvoiceSchedule,
      Error,
      CreateRecurringInvoiceParams
    > = {
      mutationFn: createRecurringInvoice,
      onError: createErrorHandler({
        customHandlers: {
          400: () => "Invalid recurring invoice data provided",
          403: () => "Unauthorized to create recurring invoice",
        },
      }),
    };
    return { ...defaultOptions, ...options };
  },
  useMutation: (
    options?: UseMutationOptions<
      RecurringInvoiceSchedule,
      Error,
      CreateRecurringInvoiceParams
    >
  ) => {
    const mutationOptions = recurringInvoiceCreate.createOptions(options);
    return useMutation<
      RecurringInvoiceSchedule,
      Error,
      CreateRecurringInvoiceParams
    >(mutationOptions);
  },
};
